let containerShowMore = document.querySelectorAll(".js-showMore");

if (containerShowMore) {
  containerShowMore.forEach(showMore => {
    let items = showMore.querySelectorAll(".js-items > *")
    let button = showMore.querySelector(".js-button")

    // Only show 4 items by default
    items.forEach((item, index) => {
      if (index > 3) {
        item.classList.add('--hidden')
      }
    })

    // Show all item on click button
    button.addEventListener('click', () => {
      items.forEach(item => {
        item.classList.remove('--hidden')
        button.style.display = 'none'
      })
    })

  });
}
